import { defineMessages } from 'react-intl';

export default defineMessages({
  notFound: {
    id: 'comp.staticAccordion.notFound',
    defaultMessage: 'Oops, biller not found',
  },
  notFoundDesc: {
    id: 'comp.staticAccordion.notFoundDesc',
    defaultMessage:
      'Seems like we can’t find the provider you’re looking for. Please check your spelling and try again.',
  },
  searchRes: {
    id: 'comp.staticAccordion.searchRes',
    defaultMessage: 'SEARCH RESULTS',
  },
});
